import React from 'react';
import dayjs from 'dayjs';
import {DatePicker, Layout} from '@di-nxt/components';
import {t} from '../../../localization';
import {TeamMember} from '../../../services';
import {MemberFieldEditor} from '../Components';

type Props = {
  member: TeamMember;
  disabled: boolean;
  onEditModeChanged: (t: boolean) => void;
};

export const EmploymentStartDateEditor: React.FC<Props> = ({
  member,
  disabled,
  onEditModeChanged,
}) => {
  return (
    <MemberFieldEditor
      title={t('screens.member.fields.startdate.title')}
      description={t('screens.member.fields.startdate.description')}
      editKey={'employmentStart'}
      entity={member}
      onGetDisplayValue={(input?: string) =>
        input ? dayjs(input).format('MMM D, YYYY') : '-'
      }
      disabled={disabled}
      onEditModeChanged={onEditModeChanged}>
      {(editState, setEditState) => (
        <Layout width={210}>
          <DatePicker
            onDateChanged={(date: Date) =>
              setEditState(dayjs(date).format('YYYY-MM-DD'))
            }
            selectedDate={dayjs(editState, 'MMM D, YYYY').toDate()}
          />
        </Layout>
      )}
    </MemberFieldEditor>
  );
};
